var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMdSurveyMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 48,
    viewBox: "0 0 43 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_md_survey_medical",
    transform: "translate(21.5 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_md_survey_medical-2",
    "data-name": "ic_md_survey_medical",
    transform: "translate(-21.5 -24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15465",
    "data-name": "Rectangle 15465",
    width: 36,
    height: 42,
    rx: 4,
    transform: "translate(2 2)",
    fill: "#b87631"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15466",
    "data-name": "Rectangle 15466",
    width: 36,
    height: 41,
    rx: 4,
    transform: "translate(2 2)",
    fill: "#f1a961"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15467",
    "data-name": "Rectangle 15467",
    width: 26,
    height: 32,
    transform: "translate(7 7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147897",
    "data-name": "Path 147897",
    d: "M37,2.5a4,4,0,0,1,4,4v34a4,4,0,0,1-4,4H9a4,4,0,0,1-4-4V6.5a4,4,0,0,1,4-4H37m0-2H9a6,6,0,0,0-6,6v34a6,6,0,0,0,6,6H37a6,6,0,0,0,6-6V6.5A6,6,0,0,0,37,.5Z",
    transform: "translate(-3 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147898",
    "data-name": "Path 147898",
    d: "M36,7.5v32H10V7.5H36m0-2H10a2,2,0,0,0-2,2v32a2,2,0,0,0,2,2H36a2,2,0,0,0,2-2V7.5A2,2,0,0,0,36,5.5Z",
    transform: "translate(-3 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147899",
    "data-name": "Path 147899",
    d: "M31.17,27.5H14.83a1,1,0,1,1,0-2H31.17a1,1,0,0,1,0,2Z",
    transform: "translate(-3 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147900",
    "data-name": "Path 147900",
    d: "M24.17,31.5H14.83a1,1,0,1,1,0-2h9.34a1,1,0,0,1,0,2Z",
    transform: "translate(-3 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147901",
    "data-name": "Path 147901",
    d: "M28,15.83v3.34H24.67V22.5H21.33V19.17H18V15.83h3.33V12.5h3.34v3.33Z",
    transform: "translate(-3 -0.5)",
    fill: "#d84f10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147902",
    "data-name": "Path 147902",
    d: "M18.36,36.84a2.23,2.23,0,0,1-1.5-.58c-.53-.47-1.49.09-1.5.1a1,1,0,0,1-1-1.7,3.31,3.31,0,0,1,3.87.09c.14.13.3.13,1-.15a3.27,3.27,0,0,1,2.19-.26,17.84,17.84,0,0,0,2.78.5,1,1,0,1,1-.2,2,19.3,19.3,0,0,1-3.18-.59,2.15,2.15,0,0,0-.88.23,4.53,4.53,0,0,1-1.58.36Z",
    transform: "translate(-3 -0.5)",
    fill: "#176fa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147903",
    "data-name": "Path 147903",
    d: "M28,17.5v1.67H24.67V22.5H21.33V19.17H18V17.5Z",
    transform: "translate(-3 -0.5)",
    fill: "#c2470d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147904",
    "data-name": "Path 147904",
    d: "M45,39.82a7.69,7.69,0,0,1-15.37,0,6.63,6.63,0,0,1,.07-1,7.68,7.68,0,0,1,15.23,0A6.63,6.63,0,0,1,45,39.82Z",
    transform: "translate(-3 -0.5)",
    fill: "#75b052"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147905",
    "data-name": "Path 147905",
    d: "M44.93,38.32a7.5,7.5,0,0,1-7.61,6.18,7.5,7.5,0,0,1-7.62-6.18,7.49,7.49,0,0,1,7.62-6.19,7.49,7.49,0,0,1,7.61,6.19Z",
    transform: "translate(-3 -0.5)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147906",
    "data-name": "Path 147906",
    d: "M37.32,48.5A8.69,8.69,0,1,1,46,39.82a8.69,8.69,0,0,1-8.68,8.68Zm0-15.37A6.69,6.69,0,1,0,44,39.82,6.69,6.69,0,0,0,37.32,33.13Z",
    transform: "translate(-3 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147907",
    "data-name": "Path 147907",
    d: "M32.83,40.12a.46.46,0,0,1,0-.65l.65-.65a.46.46,0,0,1,.65,0l2,2L40.5,36.5a.46.46,0,0,1,.65,0l.66.66a.46.46,0,0,1,0,.65l-5.32,5.32a.47.47,0,0,1-.66,0Z",
    transform: "translate(-3 -0.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15468",
    "data-name": "Rectangle 15468",
    width: 18,
    height: 4,
    transform: "translate(11 4.59)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147908",
    "data-name": "Path 147908",
    d: "M32,5.09v4H14v-4H32m0-2H14a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H32a2,2,0,0,0,2-2v-4A2,2,0,0,0,32,3.09Z",
    transform: "translate(-3 -0.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15469",
    "data-name": "Rectangle 15469",
    width: 18,
    height: 2,
    transform: "translate(11 6.59)",
    fill: "#777"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMdSurveyMedical);
export default __webpack_public_path__ + "static/media/ic_md_survey_medical.5db1ac8914b786cefc0f57b272c38914.svg";
export { ForwardRef as ReactComponent };